import {
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  collection,
  addDoc,
  onSnapshot,
  serverTimestamp,
  query,
} from "firebase/firestore";

import { db } from "../firebase";

const firestoreService = {
  // Generic method to retrieve items from a given collection or subcollection with a WHERE clause
  async getWhere(collectionPath, whereClause) {
    try {
      const collectionRef = collection(db, collectionPath);
      const querySnapshot = await getDocs(query(collectionRef, whereClause));

      const items = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      return items;
    } catch (error) {
      console.error("Error fetching documents: ", error);
      throw error;
    }
  },

  // Generic method to get a single item by its ID
  async get(collectionPath, id) {
    try {
      const docRef = doc(db, collectionPath, id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() };
      }
    } catch (error) {
      console.error("Error fetching document: ", error);
      throw error;
    }
  },

  // Generic method to create a new item in a given collection or subcollection
  async create(collectionPath, data) {
    try {
      const docRef = await addDoc(collection(db, collectionPath), {
        ...data,
        createdAt: serverTimestamp(),
      });

      console.log("Document written with ID: ", docRef.id);

      return docRef.id;
    } catch (error) {
      console.error("Error adding document: ", error);
      throw error;
    }
  },

  // Generic method to create a new item in a given collection or subcollection
  async createWithId(collectionPath, id, data) {
    try {
      const docRef = doc(db, collectionPath, id);

      await setDoc(docRef, {
        ...data,
        createdAt: serverTimestamp(),
      });

      console.log("Document written with ID: ", docRef.id);

      return docRef.id;
    } catch (error) {
      console.error("Error adding document: ", error);
      throw error;
    }
  },

  // Generic method to update an existing item in a collection or subcollection
  async update(collectionPath, id, data) {
    try {
      const docRef = doc(db, collectionPath, id);

      await updateDoc(docRef, {
        ...data,
        updatedAt: serverTimestamp(),
      });

      console.log("Document updated successfully.");
    } catch (error) {
      console.error("Error updating document: ", error);
      throw error;
    }
  },

  // Generic method to delete an item from a collection or subcollection
  async delete(collectionPath, id) {
    try {
      const docRef = doc(db, collectionPath, id);
      await deleteDoc(docRef);
      console.log("Document deleted successfully.");
    } catch (error) {
      console.error("Error deleting document: ", error);
      throw error;
    }
  },

  // Real-time listener for item
  subscribeToItem(collectionPath, id, queryConstraints, callback) {
    const docRef = doc(db, collectionPath, id);
    const q = query(docRef, ...queryConstraints);

    // Use Firestore onSnapshot to listen to real-time updates
    return onSnapshot(q, (snapshot) => {
      let item;

      if (snapshot.exists()) {
        item = { id: snapshot.id, ...snapshot.data() };
      }

      callback(item); // Call the callback function with the updated item
    });
  },

  // Real-time listener for collection
  subscribeToCollection(collectionPath, queryConstraints, callback) {
    const collectionRef = collection(db, collectionPath);
    const q = query(collectionRef, ...queryConstraints);

    // Use Firestore onSnapshot to listen to real-time updates
    return onSnapshot(q, (snapshot) => {
      const items = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      callback(items); // Call the callback function with the updated items list
    });
  },
};

export default firestoreService;
